/* eslint-disable @typescript-eslint/camelcase */
import { BcsFlag, FcsFlag } from "../unleash";

/**
 * Cargo v2 (Daftar Kargo) – permission flags per path.
 * Used by router meta.permission to gate access. Namespace: featureCargoV2.
 * permission_cargo_v2_booking_list gates all list tabs (Berhasil, Dalam Proses, Dibatalkan/Gagal).
 * Create (incl. create/rtc, create/manual) and rebooking share permission_cargo_v2_create.
 */
const FcsPermissionCargoV2 = {
  permission_cargo_v2_enable: new FcsFlag.Flag(false),
  permission_cargo_v2_booking_list: new FcsFlag.Flag(false),
  permission_cargo_v2_create: new FcsFlag.Flag(false),
  permission_cargo_v2_detail: new FcsFlag.Flag(false),
  permission_cargo_v2_edit: new FcsFlag.Flag(false),
  config_max_dispute_weight: new FcsFlag.NumberFlag(3),
  permission_cargo_v2_download_awb_receipt_sync_enable: new FcsFlag.Flag(false),
  permission_history_departure_status: new FcsFlag.Flag(false),
  permission_cargo_v2_search_flight_show_calendar: new FcsFlag.Flag(false)
};

const BcsPermissionCargoV2 = {
  weight_validation_dsipute: new BcsFlag.JSONFlag({
    truck: {
      weight: 10000,
      piece: 1000
    },
    ship: {
      weight: 20000,
      piece: 2000
    }
  }),
  config_whitelist_client_max_dispute_weight: new BcsFlag.JSONFlag([]),
  config_search_flight_max_selectable_days: new BcsFlag.NumberFlag(4),
  // Booking cargo plane weight/piece limits by route class (domestic/international).
  // Booking-only: does not affect Cargo Configuration or truck/ship, which keep weight_validation_dsipute.
  config_weight_piece: new BcsFlag.JSONFlag({
    plane: {
      domestic: {
        weight: 400,
        piece: 15
      },
      international: {
        weight: 2000,
        piece: 15
      }
    }
  })
};

export const FlagsPermissionCargoV2 = {
  ...FcsPermissionCargoV2,
  ...BcsPermissionCargoV2
};

export function initFlagsPermissionCargoV2() {
  FcsFlag.register("featureCargoV2", FcsPermissionCargoV2);
  BcsFlag.register("featureCargoV2", BcsPermissionCargoV2);
}
